module.exports = __webpack_public_path__ + "static/determined-expanded-2-b778263c133921f4b90ba6c7395130b6.png";